module.exports = __webpack_public_path__ + "static/media/goal_reached.98f6fcbe.jpg";